import { screenSize } from '@/utils/Utils'
import { ref, onMounted, onBeforeUnmount } from 'vue'

export function useIsSmallScreen() {
    const isSmallScreen = ref(screenSize.isLessThan('md'))

    const handleResize = () => {
        isSmallScreen.value = screenSize.isLessThan('md')
    }

    onMounted(() => {
        window.addEventListener('resize', handleResize)
    })

    onBeforeUnmount(() => {
        window.removeEventListener('resize', handleResize)
    })

    return {
        isSmallScreen
    }
}
